export const LOADING = 'LOADING';
export const LOADED = 'LOADED';
export const LOGOUT = "LOGOUT";
export const LOGIN = "LOGIN";
export const REGISTER = "REGISTER";
export const VERIFY = "VERIFY";
export const ERROR = "ERROR";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const VERIFY_ERROR = "VERIFY_ERROR";
export const USERS = "USERS";